module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"nothing_to_install":"Nothing to install"},"ua":{"nothing_to_install":"Нема що встановлювати"},"ru":{"nothing_to_install":"Нечего устанавливать"}}')
  delete Component.options._Ctor
}
